'use client'

import { motion } from 'motion/react'

import { FormMessage } from '@/components/FormMessage'
import { CMSLink } from '@/components/Link'

export const PaymentSuccessScreen = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      exit={{ opacity: 0, y: 8 }}
      className="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center"
    >
      <FormMessage
        type="success"
        message="Thank you for your support! Your generous contribution strengthens our work to challenge harmful systems, defend health freedom, and advance meaningful reform for a healthier future for everyone. Stay informed on all things MAHA®"
      />
      <CMSLink
        type="custom"
        label="Join us"
        url="/sign-up"
        appearance="default"
        variant="accent"
        color="default"
        className="mt-6 w-fit"
      />
    </motion.div>
  )
}
